// Treat empty / whitespace-only / case-insensitive "null" as "no memo set"
// (returns null). Real memos are trimmed. Used wherever this app sends a memo
// to the API, so an admin typing the literal word "null" (or a stale "null"
// pre-filling a form from previously-saved bad data) can't reach the printer.
// See D4URX-2693 for full root cause.
export function normalizeMemo(memo: unknown): string | null {
  if (memo === null || memo === undefined) return null;
  if (typeof memo !== 'string') {
    const stringValue = String(memo).trim();
    if (!stringValue) return null;
    return stringValue.toLowerCase() === 'null' ? null : stringValue;
  }

  const trimmedMemo = memo.trim();
  if (!trimmedMemo) return null;
  return trimmedMemo.toLowerCase() === 'null' ? null : trimmedMemo;
}
